import React from "react"
import { useTheme } from "@material-ui/core/styles"
import { useTranslation } from "react-i18next"
import config from "../../../../config"
import { useSelector } from "react-redux"

export default function Tonality({ resultData, ai = false, tabIndex }) {
    const {
        theme: { bgColors, colors },
    } = useTheme()
    const { t } = useTranslation()
    const themeState = useSelector(state => state.userData.theme || localStorage.getItem('theme') || config.THEMES_MODES.LIGHT)
    
    const isContrast = themeState !== config.THEMES_MODES.LIGHT

    return (
        <div className="mb-2 d-flex flex-column align-items-center w-100" style={{ backgroundColor: bgColors.bgPrimary100, maxWidth: "140px", height: "100px", overflow: "hidden", padding: "2px 15px", marginLeft: ai ? "7px" : "15px", borderRadius: "10px", filter: "drop-shadow(0 0 3px rgba(0, 0, 0, 0.161))" }} title={t("accessibility_analysis_tonality")} tabIndex={tabIndex}>
            <p className="font-weight-bold" style={{ color: isContrast ? colors.colorContrast : colors.colorPrimary700, fontSize: "0.75rem" }}>
                {t("Tonality")}
            </p>
            <div className="w-100 d-flex px-1 pb-3 flex-column justify-content-between" style={{ gap: "4px", flexGrow: 1 }}>
                {Object.entries(config.tonalityParameters).map(([key, val]) => {
                    if (resultData[key] !== undefined) {
                        const width =
                            ((resultData[key] - val.scaleFrom[0]) /
                                (val.scaleTo[0] - val.scaleFrom[0])) *
                            100

                        return (
                            <div key={`row-${key}`} className="w-100">
                                <p
                                    className="mb-1"
                                    style={{ fontSize: "0.65rem", color: isContrast ? colors.colorContrast : colors.colorPrimary700 }}
                                >
                                    {t(val.nameOnTop)}
                                </p>
                                <div
                                    className="position-relative rounded"
                                    style={{
                                        backgroundColor: bgColors.bgPrimary300,
                                        height: "4px",
                                        width: "100%",
                                    }}
                                >
                                    <div
                                        className="rounded"
                                        style={{
                                            width: `${width}%`,
                                            height: "100%",
                                            backgroundColor: isContrast ? bgColors.bgCockpitBar : bgColors.bgBar,
                                        }}
                                    ></div>
                                </div>
                            </div>
                        )
                    }
                    return null
                })}
            </div>
        </div>
    )
}
